import { Box, CircularProgress, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { fetchQuickBooksOAuthCallback } from '@sophocles/api/quickbooks';

export default function QuickBooksCallbackView() {
  const { t } = useTranslation();
  useEffect(async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const code = urlSearchParams.get('code');
    window.history.replaceState({}, document.title, '/staff/billing/quickbooks');

    if (!code) {
      window.location.href = '/staff/engineering/quickbooks?failed=true';
    } else {
      const data = await fetchQuickBooksOAuthCallback(code);

      if (!data.id_token) {
        window.location.href = '/staff/engineering/quickbooks?failed=true';
      }

      window.location.href = '/';
    }
  }, []);

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress />
      <Typography>{t('billing.signingYouIn', 'Signing you in...')}</Typography>
    </Box>
  );
}
